import Styled from 'styled-components';

export const Container = Styled.div`
	font-family: ${props => props.theme.fontFamily};
	display: inline-block;
	max-width: ${props => `${props.maxWidth}px`};
	min-width: 50px;
	height: 34px;
	border-radius: 2px;
	background-color: ${props => (props.disabled ? '#e6e6e6' : '#6e0fea')};
	padding: 4px 7px 4px 10px;
	color: ${props => (props.disabled ? '#545454' : '#fff')};
`;

export const ContentContainer = Styled.div`
	cursor: default;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content:space-between;
`;

export const TextContainer = Styled.div`
	overflow: hidden;
	margin-right: 10px;
`;

export const Title = Styled.div`
	opacity: 0.7;
	font-size: 9px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Text = Styled.div`
	overflow: hidden;
	font-size: 11px;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const IconContainer = Styled.div`
	cursor: pointer;
	&:hover {
		opacity: 0.8;
	}
`;
